import { render, staticRenderFns } from "./RevenueReportTotalComponent.vue?vue&type=template&id=47a8be80&"
import script from "./RevenueReportTotalComponent.vue?vue&type=script&lang=js&"
export * from "./RevenueReportTotalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports